import { ReactNode } from "react";
import IconButton from "../IconButton";

type ToastProps = {
  dismissible?: boolean;
  onDismiss: () => void;
  dismissButtonVariant?: "primary" | "secondary" | "inverted";
  layer?: "default" | "modal";
  children?: ReactNode;
};

const Toast = ({ children, dismissible, onDismiss, dismissButtonVariant = "secondary", layer = "default" }: ToastProps): JSX.Element => {
  const layerClass = layer === "modal" ? "z-[1000000002]" : "z-[900]";

  return (
    <div className={`fixed bottom-5 right-1/2 ${layerClass} flex translate-x-1/2 items-center justify-between gap-3 rounded-[5px] bg-[var(--grey-0)] px-5 py-4 font-medium text-[17px] text-[var(--context-menu-text)] shadow-[var(--default-drop-shadow)]`}>
      <div className="flex-1 text-[var(--context-menu-text)] [&>a]:pl-[10px] [&>a]:text-[var(--context-menu-text)] [&>a]:underline [&>a]:underline-offset-2 [&>svg]:mr-2 [&>svg_success_path]:fill-[var(--success-color)] [&>svg_failed_path]:fill-[var(--danger-color)]">
        {children ?? null}
      </div>
      {dismissible && (
        <IconButton
          src="/assets/close.svg"
          onClick={onDismiss}
          ariaLabel="Dismiss toast"
          hoverTipText="Close"
          className="close [&_svg]:mr-0"
          size={32}
          iconSize={16}
          variant={dismissButtonVariant || "secondary"}
          disableHoverTipArrow={false}
        />
      )}
    </div>
  );
};

export default Toast;
